import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useState } from 'react';
import { ERROR_MESSAGES } from '../../../configs/messages';
import showMessage from '../../../helpers/showMessage';
import { useSnackbar } from 'notistack';
import axios from 'axios';

// import { useAuth } from '../../providers/AuthProvider';
// import { Grid } from '@mui/material';
// import { ROUTES_LIST } from '../../../helpers/routesList';
// import { NavLink } from 'react-router-dom';

function Copyright(props) {
    return (
        <Typography
            variant="body2"
            color="text.secondary"
            align="center"
            {...props}
        >
            {'Зохиогчийн эрх © '}
            <Link color="inherit" href="https://www.mongolcontent.mn/">
                Mongol Content
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}

const theme = createTheme();

export default function RestorePassword() {
    const [errors, setErrors] = useState({});
    const [data, setData] = useState({
        email: '',
    });

    const { enqueueSnackbar } = useSnackbar();

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setData({
            ...data,
            [name]: value,
        });
    };

    const validate = () => {
        let tempErrors = { ...errors };
        const requiredMessage = ERROR_MESSAGES.FILL_THE_FIELD;

        if ('email' in data) {
            tempErrors.email = data.email ? '' : requiredMessage;
        }

        setErrors({
            ...tempErrors,
        });

        return tempErrors;
    };

    const path = '/reset-url'
    const url = process.env.REACT_APP_CMS_API_PATH + path;

    const handleSubmit = async (e) => {
        e.preventDefault();
    
        const tempErrors = validate();
    
        for (const key in tempErrors) {
            if (tempErrors[key]) {
                showMessage(
                    ERROR_MESSAGES.FILL_THE_FORM,
                    enqueueSnackbar,
                    'error',
                );
                return;
            }
        }
    
        try {
            const response = await axios.post(url, { email: data.email });
            console.log("response end", response)
            showMessage(response.data?.data, enqueueSnackbar);
        } catch (err) {
            const errorMessage = err.response?.data?.message || err.message;
            showMessage(
                errorMessage,
                enqueueSnackbar,
                'error',
            );

        }
    };

    return (
        <ThemeProvider theme={theme}>
            <Container component="main" maxWidth="xs">
                {/* <CssBaseline /> */}
                <Box
                    sx={{
                        marginTop: 8,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
                        <LockOutlinedIcon />
                    </Avatar>
                    <Typography component="h1" variant="h5">
                        Нууц үг сэргээх
                    </Typography>
                    <Box
                        component="form"
                        onSubmit={handleSubmit}
                        noValidate
                        sx={{ mt: 1 }}
                    >
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            type="email"
                            id="email"
                            label="И-мэйл хаяг"
                            name="email"
                            autoComplete="email"
                            autoFocus
                            onChange={handleInputChange}
                            error={Boolean(errors.email)}
                            helperText={errors.email}
                        />
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            sx={{ mt: 3, mb: 2 }}
                        >
                            Нууц үгээ сэргээх
                        </Button>
                        {/* <Grid container>
                            <Grid item xs>
                                <NavLink
                                    to={ROUTES_LIST.restorePassword}
                                >
                                    Нууц үгээ мартсан?
                                </NavLink>
                            </Grid>
                        </Grid> */}
                    </Box>
                </Box>
                <Copyright sx={{ mt: 8, mb: 4 }} />
            </Container>
        </ThemeProvider>
    );
}
